module.exports = __webpack_public_path__ + "static/card-1-f5304716e32addfed141af7368ca55b1.png";